import { create } from 'zustand'

const collectionStores = {}

export const createStoreForCollection = (collectionId, name, location) => {
  if (!collectionStores[collectionId]) {
    collectionStores[collectionId] = create(set => ({
      feels: [],
      isChangedFeels: false,
      removedFeels: [],
      collectionName: name,
      collectionNameInfo: {
        isChanged: false,
        initialValue: null,
      },
      collectionLocation: location,
      collectionLocationInfo: {
        isSelected: false,
        initialValue: null,
      },
      showSave: false,
      collectionDescription: '',
      collectionDescriptionInfo: {
        isChanged: false,
        initialValue: null,
      },
      backdropImage: null,
      collectionKeywords: [],
      collectionKeywordsInfo: { isChanged: false, initialValue: null },

      setFeels: newFeels => set({ feels: newFeels }),
      setIsChangedFeels: newState => set({ isChangedFeels: newState }),
      setRemovedFeels: newFeels => set({ removedFeels: newFeels }),
      setCollectionName: newName => set({ collectionName: newName }),
      setCollectionNameInfo: newValue => set({ collectionNameInfo: newValue }),
      setCollectionLocation: newLocation =>
        set({ collectionLocation: newLocation }),
      setCollectionLocationInfo: newValue =>
        set({ collectionLocationInfo: newValue }),
      setShowSave: newState => set({ showSave: newState }),
      setCollectionDescription: newDesc => set({ collectionDescription: newDesc }),
      setCollectionDescriptionInfo: newValue =>
        set({ collectionDescriptionInfo: newValue }),
      setBackdropImage: url => set({ backdropImage: url }),
      setCollectionKeywords: newKeywords => set({ collectionKeywords: newKeywords }),
      setCollectionKeywordsInfo: newValue => set({ collectionKeywordsInfo: newValue }),
    }))
  }

  return collectionStores[collectionId]
}